import { BackendError } from "@exceptions";
import * as Sentry from "@sentry/react";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

import NotFound from "./404";
import GenericError from "./generic";

export default function ErrorComponent() {
  const error = useRouteError() as Error;
  const { t } = useTranslation();

  const handleReset = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  useEffect(() => {
    window.addEventListener("online", handleReset);
    return () => window.removeEventListener("online", handleReset);
  }, [handleReset]);

  if (error instanceof BackendError && error.statusCode === 404) {
    return <NotFound message={error.message} />;
  }

  const message =
    import.meta.env.VITE_ENVIRONMENT === "local" ? error.message : undefined;

  return (
    <GenericError
      message={message}
      actionLabel={t("tryAgain")}
      onAction={handleReset}
    />
  );
}
